import { useStore } from 'react-redux';
import configureStore from '../redux/store';

/** a more precisely typed version of {@link useStore} */
export default function useAppStore(): ReturnType<typeof configureStore> {
  return useStore();
}
